<template>
    <div class="boxes">
      <img src="../assets/boxesTypo.svg" class="typo">
      <div class = "thumbNail" id="thumbNail">
        <img class="thumbNailImg" src='@/assets/SPhoto/SPhoto01.jpg' id="thumbNailImg">
      </div>
      <div class="boxesContainer">
        <div v-for="boxid in boxes" :key="boxid" class="box" :id="boxid" @click="showImg(boxid)">
          <img :src="require(`@/assets/Main${boxid}.svg`)" class="label">
        </div>
        <div class="randBox" @click="gotoRandom"><img src='@/assets/Main00.svg' class="label"></div>
      </div>
    </div>
</template>

<style scoped>

.thumbNail {
  visibility: hidden;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 99;
  background-color: #0d00b4;
}

.label {
  height: 14px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  outline: dashed 1.2px white;
}

.thumbNailImg {
  position: absolute;
  left: 0px;
  width: 100%;
  height: 100%;
  opacity: 0.6;
  object-fit:cover;
}

.boxes {
  background-image: url('../assets/boxesBg.svg');
  background-size: cover;
  overflow: scroll;
  text-align: center;
  background-position: bottom;
}

.randBox {
  background-color: #0d00b4;
}

.typo {
  position: relative;
  width: 250px;
  top: min(15vh, 150px);
}

.boxesContainer {
  position: relative;
  display: grid;
  top: min(25vh, 200px);
  width: 80vw;
  left: 10vw;
  height: 50vh;
  grid-template-columns: repeat(4,1fr);
  grid-template-rows: repeat(7,1fr);
  gap: 5px 5px;
}

.box {
  background-color: #0d00b4;
  background-size: cover;
  position: relative;
}

.toHomeBox {
  background-color: white;
}
</style>

<script setup>
import { useRouter } from 'vue-router'
const router = useRouter()
router.beforeEach(function(to, from, next){
  if(to.path == '/2') {
    to.meta.transition = 'slide-left'
    from.meta.transition = 'slide'
  }
  else {
    to.meta.transition = 'slide'
  }
  window.removeEventListener("touchstart",startevent);
  window.removeEventListener("touchend", endevent);
  next();
});

function startevent(event) {
  if(event.touches.length === 1){
    start = event.touches.item(0).clientX;
  }else{
    start = null;
  }
}

function endevent(event) {
  var offset = 100;
  if(start){
    var end = event.changedTouches.item(0).clientX;
    if(end > start + offset){
      router.push('/2');
    }
    else if(end < start - offset ){
      router.push('/main/01');
    }
  }
}

var start = null;
window.addEventListener("touchstart",startevent);
window.addEventListener("touchend", endevent);

const boxes = [ "20", "16", "18", "09", "07", "11", "21", "26", "24", "08", "27", "25", "13", "02", "03", "22", "17", "12", "01", "06", "23", "04", "19", "05", "14", "15", "10" ]

/*function goToMain(boxid) {
  const imageUrl = `@/assets/SPhoto/SPhoto${boxid}.jpg`;
  
  let box = document.getElementById(boxid);
  box.style.backgroundColor = 'white';
  box.style.cssText+=`background-image:url(${require(imageUrl)})`;
  setTimeout(() => router.push('/main/'+boxid), 1000);
}*/


function showImg(boxid) {
  let box = document.getElementById(boxid);
  const pos = box.getBoundingClientRect();
  let thumb = document.getElementById("thumbNail");
  let thumbImg = document.getElementById("thumbNailImg");
  thumbImg.src = require(`../assets/SPhoto/SPhoto${boxid}.jpg`);
  thumb.style.left = pos.left + 'px';
  thumb.style.top = pos.top + 'px';
  thumb.style.width = pos.width + 'px';
  thumb.style.height = pos.height + 'px';
  thumb.style.visibility = 'visible';
  setTimeout(() => router.push('/main/'+boxid), 300);
}
function gotoRandom() {
  const minCeiled = Math.ceil(1);
  const maxFloored = Math.floor(28);
  const randbox = Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // 최댓값은 제외, 최솟값은 포함
  const randboxid = String(randbox).padStart(2, "0");
  showImg(randboxid);
}


</script>